import mirror from 'keymirror';
import { trackAuthUser } from '@fenderdigital/analytics';
import Leads from '../lib/leads';

export const actionTypes = mirror({
  LEADS_POST_ERROR: null,
  LEADS_POST_IN_PROGRESS: null,
  LEADS_POST_SUCCESS: null,
});

const leadsPostError = error => ({
  type: actionTypes.LEADS_POST_ERROR,
  error,
});

const leadsPostInProgress = () => ({
  type: actionTypes.LEADS_POST_IN_PROGRESS,
});

const leadsPostSuccess = email => ({
  type: actionTypes.LEADS_POST_SUCCESS,
  email,
});

export const createLead = (email, locale) => async dispatch => {
  dispatch(leadsPostInProgress());
  const siteId = process.env.REACT_APP_CLIENT_SITE_ID;
  trackAuthUser(siteId, {});
  try {
    const lead = await Leads.create(email, locale);
    dispatch(leadsPostSuccess(lead));
  } catch (err) {
    dispatch(leadsPostError(err));
  }
};
